/**
 * Off-canvas mobile menu
 */

import $ from 'jquery';
import { getPageId, getActiveMenuItem } from 'components/navigation/active-menu-item.js';

const mobileMenuContainer = document.querySelector('#off-canvas-mobile-menu');
const pageId = getPageId();

if (mobileMenuContainer) {
  const audienceDropdown = mobileMenuContainer.querySelector('details.dropdown-audience');

  // Off-canvas opened event
  $(document).on('opened.zf.offCanvas', function() {
    // Audience menu
    // On tall screens the audience list is always visible — open the details panel
    // if (audienceDropdown && window.innerHeight >= 700) {
    //   audienceDropdown.open = true;
    // }

    // Navigate to active menu item if applicable
    // Accordion menu
    if (pageId && mobileMenuContainer.querySelector('[data-accordion-menu')) {
      const activeMenuItem = getActiveMenuItem(mobileMenuContainer, '[data-accordion-menu]');

      if (activeMenuItem) {
        const [activeMenuContainer, activeMenu, activeLink] = activeMenuItem;
        if (activeLink && activeMenu && activeMenuContainer) {
          // Set active class
          activeLink.classList.add('is-active');

          // Open each accordion submenu
          $(activeMenu).parentsUntil(activeMenuContainer, 'ul').each(function() {
            $(activeMenuContainer).foundation('down', $(this));
          });
          $(activeMenuContainer).foundation('down', $(activeMenu));
        }
      }
    }
    // Drilldown menu
    if (pageId && mobileMenuContainer.querySelector('[data-drilldown')) {
      const activeMenuItem = getActiveMenuItem(mobileMenuContainer, '[data-drilldown]');
      if (activeMenuItem) {
        const [activeDrilldown, activeMenu, activeLink] = activeMenuItem;
        if (activeLink && activeMenu && activeDrilldown) {
          // Set active class
          activeLink.classList.add('is-active');

          // Open relevant drilldown submenu
          $(activeDrilldown).foundation('_showMenu', $(activeMenu), false);

          // If active link is a submenu parent (folder index) open its submenu
          const activeLinkLi = activeLink.closest('li');
          if (activeLinkLi) {
            const childSubmenu = activeLinkLi.querySelector('ul.menu');
            if (childSubmenu) {
              $(activeDrilldown).foundation('_showMenu', $(childSubmenu), false);
            }
          }
        }
      }
    }
  });

  // Reset audience dropdown on close
  $(document).on('closed.zf.offCanvas', function() {
    if (audienceDropdown) {
      audienceDropdown.open = false;
    }
  });
}